import SearchSuggestion from './searchSuggestion';
export default SearchSuggestion;
